export class GetSimplePackingLabelInput {
    orderIds: number[];
}